<template>
  <section id="admin-filter">
    <h4>Financial Profile filter</h4>
    <div class="form-group">
      <label for="filter-calc-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="filter-calc-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="filter-calc-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="filter-calc-name" v-model="entity.name"/>
    </div>
    <div class="form-group">
      <label for="filter-fp" class="form-label">Category</label>
      <select class="form-control" id="filter-fp" v-model="entity.category">
        <option value=""></option>
        <option v-for="(opt, i) in categories" :value="opt.value">{{ opt.name }}</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import Mixin from './Mixin'
  export default {
    name: 'FinancialProfileFilter',
    mixins: [ FilterMixin, Mixin ],
    data () {
      return {
        entity: {
          code: '',
          name: '',
          category: ''
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// FinancialProfileFilter.vue?dd7a2e70